<div class="box-shadow rounded--large guts-p-full-2 m-guts-p-full-1">
  <div class="l_flexbar guts-m-b-1">
    <h1 class="h3 l_flex-grow">{{ chartName }}</h1>
  </div>
  <table class="data-table">
    <thead>
      <tr>
        <th
          *ngFor="let header of headerList; let i = index"
          data-dgat="top-data-chart-list-37e"
          [ngClass]="{
            'left-text': i % 3 === 0,
            'right-text': i % 3 >= 1,
            l_w40: i % 3 === 0,
            l_w25: i % 3 === 2
          }"
        >
          <span class="font-medium">{{ header }}</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let item of listData; let i = index"
        data-dgat="top-data-chart-list-0cd"
      >
        <td>
          <span>{{ item[labelKey1] }} </span>
        </td>
        <td *ngIf="progressData">
          <ngb-progressbar
            type="success"
            [value]="progressData"
          ></ngb-progressbar>
        </td>
        <td class="right-text">
          {{ item[labelKey2] }}
          <!--  | number: 1  -->
        </td>
      </tr>
    </tbody>
  </table>
  <div *ngIf="listData.length === 0 && !isLoading">
    {{ i18n.Core_NoResults }}
  </div>
  <dgx-skeleton
    type="table"
    [columns]="2"
    [rows]="10"
    *ngIf="isLoading"
  ></dgx-skeleton>
</div>
